export interface PasswordRule {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: 'length', label: 'Mínimo 8 caracteres', test: (p) => p.length >= 8 },
  { id: 'upper', label: 'Uma letra maiúscula', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: 'Uma letra minúscula', test: (p) => /[a-z]/.test(p) },
  { id: 'digit', label: 'Um número', test: (p) => /[0-9]/.test(p) },
  { id: 'special', label: 'Um caractere especial', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function passwordStrength(password: string): {
  percent: number;
  passed: number;
  total: number;
  rules: { id: string; label: string; ok: boolean }[];
} {
  const rules = PASSWORD_RULES.map((r) => ({
    id: r.id,
    label: r.label,
    ok: r.test(password),
  }));
  const passed = rules.filter((r) => r.ok).length;
  const total = rules.length;
  return {
    percent: password ? Math.round((passed / total) * 100) : 0,
    passed,
    total,
    rules,
  };
}
